import React from "react";
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { getClientManagementList } from "../Actions/ClientManagementAPI";
import { toast } from "react-toastify";
import axios from "axios";
import API from "../helpers/api";
import swal from "sweetalert";

let user = JSON.parse(localStorage.getItem("currentUser"));

class FleetManagerManagementEdit extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            fleetManagerinfo: {
                role: 'fleetmanager',
                clientUserId: 0,
                name: '',
                email: '',
                phone: '',
                isDeleted: false,
                modifiedBy: ''
            },
            fleetManagerArray: []
        }
        this.handleInputChange = this.handleInputChange.bind(this);
    }

    componentDidMount() {
        this.props.dispatch({ type: 'SubBannerTitle', data: "Fleet Manager" });
    }
    static getDerivedStateFromProps(nextProps, prevState) {
        const { fleetManagerDetail, dispatch} = nextProps;
        if (fleetManagerDetail) {
            prevState.fleetManagerinfo.name = fleetManagerDetail.userName;
            prevState.fleetManagerinfo.email = fleetManagerDetail.email;
            prevState.fleetManagerinfo.phone = fleetManagerDetail.phone1;
            prevState.fleetManagerinfo.clientUserId = fleetManagerDetail.clientUserId;
            dispatch({ type: "FleetClientDetails", data: "" });
        }
      
    }

    handleInputChange(e) {
        let nodeName = e.target.name;
        this.state.fleetManagerinfo[nodeName] = e.target.value;
        this.setState({});
    }

    updateFleetManager() {
        const { dispatch, match } = this.props;
        const { fleetManagerinfo } = this.state;
        let userlist = 
            {
                clientUserId: fleetManagerinfo.clientUserId,
                name: fleetManagerinfo.name,
                role: fleetManagerinfo.role,
                email: fleetManagerinfo.email,
                phone: fleetManagerinfo.phone,
                address: "",
                isDeleted: false,
                modifiedBy:user.email
              
            }
            if (this.state.fleetManagerinfo.email !== "" && this.state.fleetManagerinfo.name !== "") {
                var pattern =
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                if (!pattern.test(this.state.fleetManagerinfo.email)) {
                    swal('Error!', 'Invalid Email', 'warning');
                    }else{
                if (this.state.fleetManagerinfo.email !== "") {
            let url2 = `${API.userExist}?Mail=${fleetManagerinfo.email}&Id=${fleetManagerinfo.clientUserId}&Role=${this.state.fleetManagerinfo.role}`
            axios.get(url2, {
                headers: {
                    key: user.accessToken
                }
            })
                .then((response) => {
                    if (response.data === true) {
                        let url = `${API.PutClientUsers}`;
                        axios.put(url, userlist, {
                            headers: {
                                key: user.accessToken,
                            }
                        })
                            .then((response) => {
                                if(response.status===200){
                                toast.success("Updated Successfully", {
                                    position: "top-right",
                                    autoClose: 5000,
                                    hideProgressBar: true,
                                    closeOnClick: true,
                                    pauseOnHover: true,
                                    draggable: true,
                                    progress: undefined,
                                  });
                                this.props.history.push("/Home/Management/FleetManager");
                              dispatch({
                                    type: "postClientUserDetailsSuccess",
                                    data: response.data,
                                })
                            }
                            })
                        
                            .catch((error) => {
                                swal(
                                    "Error!",
                                    "Something went wrong. Please try again.",
                                    "warning"
                                  );
                                dispatch({
                                    type: "postClientUserDetailsFailure",
                                    error: "ERROR"
                                })
                            })
                    } else if (response.data === false) {
                        swal('Error!', 'User already exist. Please change the email', 'warning');
                        this.state.fleetManagerinfo.email = "";
                        this.setState({});
                    }
                    dispatch({
                        type: 'getUserExistListSuccess',
                        data: response.data
                    })
                })
                .catch((error) => {
                    dispatch({
                        type: 'getUserExistListFailure',
                        data: "error"
                    })
                })
        }
    }
    } else if(this.state.fleetManagerinfo.name == "" && this.state.fleetManagerinfo.email == "") {
            swal('Error!', 'Name and Email is mandatory', 'warning');
        } else if(this.state.fleetManagerinfo.name == "") {
            swal('Error!', 'Name is mandatory', 'warning');
        } else {
            swal('Error!', 'Email is mandatory', 'warning');
        }
    }


    hideSidePanel() {
        this.props.dispatch({ type: "ShowSidePan", data: false });
        this.props.history.push("/Home/Management/FleetManager");
    }

    render() {
        const { editUser } = this.props;
        return (
            <div className="full-height">
                <div className="resource-list-auth-date row pt-3 ">
                    <div className='w-100'>
                        <div className="panel-box search-filter-box">
                            <div className="card mt-2 MM-card-header" style={{ backgroundColor: "white" }}>
                                <div className="card-body" style={{ padding: "0rem", backgroundColor: "#1E3A8A", color: "white" }}>
                                    <h5 className="card-title ml-2 mt-2" style={{ color: "092a51" }}>Fleet Managers</h5>
                                </div>
                            </div>
                            <div className="row search-filter-box">
                                <div className="col-lg-4">
                                    <label className="form-label">Name</label><br></br>
                                    <input type="text" className="form-control" name='name' value={this.state.fleetManagerinfo.name} placeholder="Name" onChange={e => this.handleInputChange(e)}></input>
                                </div>
                                <div className="col-lg-4">
                                    <label className="form-label">Email</label><br></br>
                                    <input type="email" className="form-control" name='email' value={this.state.fleetManagerinfo.email} placeholder="Email" onChange={e => this.handleInputChange(e)}></input>
                                </div>
                                <div className="col-lg-4">
                                    <label className="form-label">Phone</label><br></br>
                                    <input type="text" className="form-control" name='phone' value={this.state.fleetManagerinfo.phone} placeholder="Phone" onChange={e => this.handleInputChange(e)}></input>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-lg-12 search-filter-box">
                                    <div className="search-btn-col" style={{ textAlign: 'end' }}>
                                    
                                            <button className="btn btn-primary text-uppercase txtside-btn txtht-btn blue" type="submit" onClick={() => this.updateFleetManager()}> Update </button>
                                           <button className="btn btn-light text-uppercase txtside-btn txtht-btn ml-3" type="button" onClick={() => this.hideSidePanel()}> Cancel </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
function mapDispatchToProps(dispatch) {
    return {
        dispatch,
    }
}
function mapStateToProps(state) {
    return {
        showSidePane: state.SidePanReducer.sidePan || false,
        fleetManagerDetail: state.MasterScreenReducer.FleetClientDetails,
        
    }
}
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(FleetManagerManagementEdit));